import { Loader2 } from "lucide-react";
import { FadeInOnLoad } from "@/components/motion";

export function AppLoadingScreen({ message = "Preparing your workspace..." }: { message?: string }) {
  return (
    <div className="min-h-[100dvh] bg-[#f8f9fc] px-4 py-[max(1.5rem,env(safe-area-inset-top))]">
      <div className="mx-auto flex min-h-[100dvh] max-w-3xl items-center justify-center">
        <FadeInOnLoad direction="bottom" className="w-full text-center">
          <div className="flex justify-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white shadow-sm">
              <Loader2 className="h-5 w-5 animate-spin text-blue-600" aria-hidden="true" />
            </div>
          </div>
          <p className="mt-5 text-sm font-medium text-slate-500">{message}</p>
        </FadeInOnLoad>
      </div>
    </div>
  );
}
